"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.optimizeSizeToTexture = exports.multiplySize = exports.fitNextPOT = exports.ceilPOT = void 0;
/**
 *
 * @param {number} width
 * @param {number} height
 * @param {number} scalarValue
 * @return {{width: number, height: number}}
 */
var multiplySize = exports.multiplySize = function multiplySize(_ref, scalarValue) {
  var width = _ref.width,
    height = _ref.height;
  return {
    width: width * scalarValue,
    height: height * scalarValue
  };
};

/**
 * Returns the next power of two number
 * @param {number} x
 * @return {number}
 */
var ceilPOT = exports.ceilPOT = function ceilPOT(x) {
  return Math.pow(2, Math.ceil(Math.log(x) / Math.log(2)));
};

/**
 * Finds the next power of two size
 * @param {number} width
 * @param {number} height
 * @return {{width: number, height: number}}
 */
var fitNextPOT = exports.fitNextPOT = function fitNextPOT(_ref2) {
  var width = _ref2.width,
    height = _ref2.height;
  var ratio = width / height;
  if (ratio > 1) {
    width = ceilPOT(width);
    height = width / ratio;
  } else {
    height = ceilPOT(height);
    width = height * ratio;
  }
  return {
    width: width,
    height: height
  };
};

/**
 * Single function that does the texture size optimization in one step
 * @param {{width: number, height: number}} size
 * @param {number} pixelRatio
 * @param {boolean} fitPOT
 * @param {number} maxTextureSize
 * @return {*}
 */
var optimizeSizeToTexture = exports.optimizeSizeToTexture = function optimizeSizeToTexture(size) {
  var pixelRatio = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var fitPOT = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var maxTextureSize = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 2048;
  var _size = multiplySize(size, pixelRatio);
  var potSize = fitPOT ? fitNextPOT(_size) : _size;
  var sizeMax = Math.max(potSize.width, potSize.height);
  return sizeMax > maxTextureSize ? multiplySize(potSize, maxTextureSize / sizeMax) : potSize;
};